// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agg-counts {
  display: flex;
}
.agg-counts p {
  margin: 0.5rem;
}

.agg-count {
  flex: 1;
  display: inline-block;
  border-right: 0.0625rem solid #e9ecef;
  text-align: center;
}
.agg-count:last-child {
  border: none;
}

.filter.active {
  background-color: rgb(232.6089686099, 244.6556053812, 248.1910313901);
}
.filter:hover {
  background-color: rgb(240.4304932735, 248.269058296, 250.5695067265);
  cursor: pointer;
}

.agg-number {
  font-size: 1.875rem;
  color: #dee2e6;
}
.agg-number.active-alert {
  font-weight: 700;
  color: #e84e25;
}
.agg-number.active-number {
  font-weight: 700;
  color: #456c9b;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/aggregate/aggregate.component.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;AAFF;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,OAAA;EACA,qBAAA;EACA,qCAAA;EACA,kBAAA;AAHF;AAKE;EACE,YAAA;AAHJ;;AAQE;EACE,qEAAA;AALJ;AAQE;EACE,oEAAA;EACA,eAAA;AANJ;;AAUA;EACE,mBAAA;EACA,cCrBS;ADcX;AASE;EACE,gBAAA;EACA,cCjCE;AD0BN;AAUE;EACE,gBAAA;EACA,cCzCQ;ADiCZ","sourcesContent":["@import 'variables';\n@import 'functions';\n\n.agg-counts {\n  display: flex;\n\n  p {\n    margin: rem(8);\n  }\n}\n\n.agg-count {\n  flex: 1;\n  display: inline-block;\n  border-right: rem(1) solid $gray-200;\n  text-align: center;\n\n  &:last-child {\n    border: none;\n  }\n}\n\n.filter {\n  &.active {\n    background-color: lighten($standard-blue, 38);\n  }\n\n  &:hover {\n    background-color: lighten($standard-blue, 40);\n    cursor: pointer;\n  }\n}\n\n.agg-number {\n  font-size: rem(30);\n  color: $gray-300;\n\n  &.active-alert {\n    font-weight: 700;\n    color: $red;\n  }\n\n  &.active-number {\n    font-weight: 700;\n    color: $dark-blue;\n  }\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
